exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-popper.append-to-body{z-index:1060}.fts-popper:not(.append-to-body){z-index:1000}.popper-content{max-height:100%;max-width:100%;padding-top:.25rem;padding-bottom:.25rem;box-shadow:var(--fts-elevation-3);border-radius:.25rem;background-color:var(--fts-popover-alt-background);color:var(--fts-text);font-size:.875rem}", ""]);

// exports
